export const DEV_BASE_URL = "one.dsmotddev.toyota.com"
export const QA_BASE_URL = "one.dsmotdqa.toyota.com"
export const UAT_BASE_URL = "one.dsmotduat.toyota.com"
export const PROD_BASE_URL = "one.dsmotd.toyota.com"